











































import Vue from 'vue'
import { mapGetters } from 'vuex'
import {
  GET_IS_CAPELO,
  GET_VERSION,
  IS_USER_LOGGED_IN
} from '@/store/getter-types'
import { FETCH_LANGUAGE_LIST, FETCH_VERSIONS, LOG_USER_IN } from '@/store/action-types'
import store from '@/store'
import { Version } from '@/model/Version'
import { LoginPayload } from '@/types/payload'
import { getCookieByName } from '@/services/get-cookie-by-name'

interface ComponentData {
  username: string | undefined
  password: string | undefined
  showPassword: boolean
  usernameValidationRules: Array<any>
  passwordValidationRules: Array<any>
  formIsValid: boolean
  showErrorSnackbar: boolean
  errorMessage: string | undefined
  version: string
  showVersionError: boolean
  versionErrorMessage: string
  isAnimation: boolean
  browserId: string
}

export default Vue.extend({
  name: 'LoginPage',

  computed: {
    ...mapGetters([IS_USER_LOGGED_IN]),

    passwordFieldType (): string {
      return this.showPassword ? 'text' : 'password'
    },

    passwordFieldIcon (): string {
      return this.showPassword ? 'visibility_off' : 'visibility'
    },

    wallpaperStyle (): any {
      const baseURL =  process.env.VUE_APP_API_ROOT || ''
      return { backgroundImage: `url(${baseURL}/api/Configuration?loadIntroImage)`}
    },

    getLogo (): string {
      const baseURL =  process.env.VUE_APP_API_ROOT || ''
      return `${baseURL}/api/Configuration?loadLogo=`
    },

    getAppLogo (): string {
      if(this.isCapelo && this.isAnimation) {
        setTimeout(() => {
          this.isAnimation = false
        }, 2600)
        return require('@/assets/capelo_logo_200_60.gif')
      } else if (this.isCapelo && !this.isAnimation) {
        return require('@/assets/capelo_logo_still_200_60.png')
      } else {
        return require('@/assets/SYZpepLogo.png')
      }
    },

    isCapelo (): boolean {
      return this.$store.getters[GET_IS_CAPELO]
    }
  },

  watch: {
    [IS_USER_LOGGED_IN] (newVal: boolean): void {
      if (newVal) {
        this.$router.push('dashboard')
      }
    }
  },

  methods: {
    onToggleShowPasswordClick (): void {
      this.showPassword = !this.showPassword
    },

    async onFormSubmit (): Promise<void> {
      const form: any = this.$refs['loginForm']

      if (form.validate()) {
        const payload: LoginPayload = {
          UserName: this.username!,
          Password: this.password!
        }

        try {
          const versionData: Version = await store.dispatch(FETCH_VERSIONS)
          if (versionData && versionData.statusFrontend && versionData.statusBackend) {
            this.logUserIn(payload)
          } else {
            this.setAlertErrorMessage(versionData)
          }
        } catch {
          this.versionErrorMessage = this.$t('errors.versionErrorMessage').toString()
          this.showVersionError = true
        }
      }
    },

    async logUserIn (payload: LoginPayload): Promise<void> {
      try {
        await this.$store.dispatch(LOG_USER_IN, payload)
        await store.dispatch(FETCH_LANGUAGE_LIST)
      } catch(e) {
        this.errorMessage = e.message
        this.showErrorSnackbar = true
      }
    },

    onAlertCloseClick (): void {
      this.showVersionError = false
    },

    setAlertErrorMessage (versionData: Version): void {
      if(versionData && !versionData.statusFrontend || !versionData.statusBackend) {
        if(!versionData.statusFrontend && !versionData.statusBackend) {
          this.versionErrorMessage = this.$t('errors.versionErrorFrontendBackend', { value: versionData.frontendTableVersion, value2: versionData.frontendVersion, value3: versionData.backendTableVersion, value4: versionData.backendVersion}).toString()
        } else if(!versionData.statusFrontend) {
          this.versionErrorMessage = this.$t('errors.versionErrorFrontend', { value: versionData.frontendTableVersion, value2: versionData.frontendVersion }).toString()
        } else if(!versionData.statusBackend) {
          this.versionErrorMessage = this.$t('errors.versionErrorBackend', { value: versionData.backendTableVersion, value2: versionData.backendVersion }).toString()
        }

        this.showVersionError = true
      } else if(!versionData) {
        this.versionErrorMessage = this.$t('errors.versionErrorMessage').toString()
        this.showVersionError = true
      }
    }
  },

  created (): void {
    this.browserId = getCookieByName('AssignedBrowserName')
    const versionData: Version = store.getters[GET_VERSION]
    if(versionData && !versionData.statusFrontend || !versionData.statusBackend) {
      this.setAlertErrorMessage(versionData)
    }
  },

  data (): ComponentData {
    return {
      username: undefined,
      password: undefined,
      showPassword: false,

      usernameValidationRules: [
        (v: string): boolean | string => !!v || this.$t('errors.required').toString()
      ],

      passwordValidationRules: [
        (v: string): boolean | string => !!v || this.$t('errors.required').toString()
      ],

      formIsValid: false,
      showErrorSnackbar: false,
      errorMessage: undefined,
      version: process.env.VUE_APP_VERSION as string,
      showVersionError: false,
      versionErrorMessage: '',
      isAnimation: true,
      browserId: ''
    }
  }
})
